import React, { useEffect, useState, useCallback } from "react";
import ReactPlayer from "react-player";
import { useAuth } from "../../../../hooks";
import { VirtualScenes } from "../../../../api";
// Añadimos Header de Semantic UI para consistencia, aunque se puede usar h2 directamente
import { Header } from "semantic-ui-react";
import { hasText, htmlHasContent, hasItems } from "../guiaHelpers";
import "./Module4.scss";

const virtualScenesController = new VirtualScenes();

export function Module4({ refId }) {
  const module4 = "module_04";
  const { accessToken } = useAuth();

  const [moduleData, setModuleData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ... (lógica de fetch sin cambios)
  const fetchModuleData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await virtualScenesController.getVirtualScenesModeule(
        refId,
        accessToken,
        module4,
      );
      setModuleData(data.moduleData);
    } catch (err) {
      console.error("Error al obtener los datos del módulo:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [refId, accessToken, module4]);

  useEffect(() => {
    if (refId && accessToken) {
      fetchModuleData();
    }
  }, [refId, accessToken, fetchModuleData]);

  if (loading || error) return null;

  const { ModFourTitle, ModFourSubtitle, ModFourContent, ModFourUsescases } =
    moduleData || {};
  const videoUrl = moduleData?.ModFourVideo?.[0];

  const hasContent =
    hasText(ModFourTitle) ||
    hasText(ModFourSubtitle) ||
    htmlHasContent(ModFourContent) ||
    hasItems(ModFourUsescases) ||
    !!videoUrl;

  if (!hasContent) return null;

  return (
    <div className="module4-container">
      {hasText(ModFourTitle) && (
        <Header as="h2" className="block-title">
          {ModFourTitle}
        </Header>
      )}
      {hasText(ModFourSubtitle) && (
        <Header as="h3" className="module4-subtitle">
          {ModFourSubtitle}
        </Header>
      )}

      {htmlHasContent(ModFourContent) && (
        <div
          className="module4-subcontent tiptap-content"
          dangerouslySetInnerHTML={{ __html: ModFourContent }}
        />
      )}

      {hasItems(ModFourUsescases) && (
        <div className="module4-usecases">
          {ModFourUsescases.map((usecase) => (
            <div key={usecase._id} className="framed-box">
              {hasText(usecase.title) && (
                <h4 className="usecase-title">{usecase.title}</h4>
              )}
              {htmlHasContent(usecase.description) && (
                <div
                  className="tiptap-content"
                  dangerouslySetInnerHTML={{ __html: usecase.description }}
                />
              )}
            </div>
          ))}
        </div>
      )}

      {videoUrl && (
        <div className="video-wrapper">
          <ReactPlayer
            url={videoUrl}
            controls
            className="react-player"
            width="100%"
            height="100%"
          />
        </div>
      )}
    </div>
  );
}
